import { computed, ref } from 'vue'
import { getIdempotencyKey } from '@shared/utils'
import type { BankAccountRow } from '../types/bankAccountsDirectoryTypes'

/**
 * Owns the bank-account directory drawer's visibility, the selected row,
 * and a per-open idempotency key. The directory has no detail endpoint
 * today — the drawer body renders entirely from `selectedRow`. The
 * idempotency key is wired in advance so the shape stays reusable when
 * future mutations land.
 */
export function useBankAccountDirectoryDrawer() {
  const drawerVisible = ref(false)
  const selectedRow = ref<BankAccountRow | null>(null)
  const idempotencyKey = ref('')

  const selectedId = computed(() => selectedRow.value?.id ?? '')

  function openDrawer(row: BankAccountRow) {
    selectedRow.value = row
    idempotencyKey.value = getIdempotencyKey()
    drawerVisible.value = true
  }

  function closeDrawer() {
    drawerVisible.value = false
    selectedRow.value = null
    idempotencyKey.value = ''
  }

  return {
    drawerVisible,
    selectedId,
    selectedRow,
    idempotencyKey,
    openDrawer,
    closeDrawer,
  }
}
